import styled from 'styled-components';

import { translate } from '../../../helpers/translate.helper';
import { LabelText } from '../../../LabelText/LabelText';
import { Box } from '../../../ui/Box';
import { get } from '../../../ui/get';
import { useLubesProductTableConfig } from '../hooks/useLubesProductTableConfig';

import { TotalRowTd } from './TotalRowTd';

const CustomTr = styled.tr`
    border-top: 1px solid ${get('colors.border.subtle')} !important;
    border-right: 1px solid ${get('colors.border.subtle')} !important;
    border-left: 1px solid ${get('colors.border.subtle')} !important;
`;

export const TotalHeaderRow = () => {
    const { editPrices } = useLubesProductTableConfig();
    return (
        <CustomTr>
            <TotalRowTd colSpan={5} />

            <TotalRowTd>
                <Box display="flex" justifyContent="flex-end">
                    <LabelText>{translate('order.volume')}</LabelText>
                </Box>
            </TotalRowTd>

            <TotalRowTd />

            <TotalRowTd>
                <Box display="flex" justifyContent={editPrices ? 'flex-start' : 'flex-end'}>
                    <LabelText>{translate('offer.edit.lubes.pricePerLiter')}</LabelText>
                </Box>
            </TotalRowTd>

            <TotalRowTd>
                <Box display="flex" justifyContent="flex-end">
                    <LabelText>{translate('order.total')}</LabelText>
                </Box>
            </TotalRowTd>

            <TotalRowTd />
        </CustomTr>
    );
};
